import {BookingData} from './vet-clinic-data.model';
import {Order} from "./shop/order.model";
import {VisitXp} from "./visit-xp.model";
import {VetClinic} from "./vet-clinic.model";

/**
 * Główny model transakcyjny reprezentujący dokonaną rezerwację wizyty.
 * Materializuje intencje użytkownika (BookingData) w trwały zapis w bazie danych.
 * Agreguje status płatności, dane telemedyczne oraz synchronizację z KlinikaXP.
 */
export class VetReservation {

  /** Globalnie unikalny identyfikator rezerwacji. */
  public uuid: string;
  /** Data i czas fizycznego utworzenia rekordu w chmurze. */
  public created: Date;
  /** Identyfikator kliniki, w której dokonano rezerwacji. */
  public vetcodeId: number;
  /** Referencja do instancji kliniki. */
  public vetClinic: VetClinic;

  public firstName: string;
  public lastName: string;
  public email: string;
  public mobilePhone: string;

  /** Komentarz/Notatka zostawiona przez właściciela podczas umawiania wizyty. */
  public comment: string;

  /** Imię pacjenta (zwierzęcia) zdenormalizowane dla szybkiego renderowania list. */
  public petName: string;
  /** UUID profilu zwierzęcia, pozwalające na powiązanie wizyty z historią medyczną. */
  public petUUID: string;

  /** Relacja do konkretnego lekarza. */
  public doctorUUID: string;
  /** Identyfikator lekarza z KlinikiXP. */
  public whObjId: number;
  /** Zdenormalizowane imię i nazwisko lekarza przyjmującego. */
  public doctorName: string;

  /** Identyfikator głównego pakietu usługi. */
  public vetineoVisitTypeBundleUUID: string;
  /** Identyfikator typu wizyty. */
  public visitTypeId: number;
  /** Zdenormalizowana nazwa usługi. */
  public visitType: string;

  /** Dokładna data i czas rozpoczęcia zarezerwowanego bloku. */
  public startDateTime: string;
  /** Dokładna data i czas zakończenia zarezerwowanego bloku. */
  public endDateTime: string;

  /** Czy ta konkretna rezerwacja wymusiła na pacjencie dokonanie przedpłaty online. */
  public paymentRequired: boolean;
  /** Kwota wymagana do opłacenia rezerwacji. */
  public bookingPrice: number;

  /** Identyfikator powiązanego zamówienia finansowego. */
  public orderUUID: string;
  /** Pełny obiekt zamówienia/transakcji. */
  public order: Order;
  /** Data udanego zaksięgowania środków za tę rezerwację. */
  public paymentConfirmationDate: string;

  /** Czas, do którego termin w kalendarzu jest "zamrożony" dla tego użytkownika,
   * dając mu czas na sfinalizowanie przelewu.
   */
  public lockDate: string;

  /** Typ rezerwacji. */
  public reservationType: string;

  /** Status potwierdzenia. */
  public confirmationStatus: string;

  /** Notatki systemowe dotyczące linku płatności. */
  public linkNotes: string;

  /** Data i czas odwołania wizyty (jeśli wystąpiło). */
  public canceled: Date;
  /** Tekstowy powód anulowania wizyty. */
  public cancellationReason: string;
  /** Kategoryzacja źródła anulacji. */
  public cancelationType: string;


  /** Flaga oznaczająca rezerwację na wizytę online. */
  public online: boolean;
  /** Czy środki komunikacyjne są włączone dla tej rezerwacji. */
  public communicationToolsEnabled: boolean;
  /** Czy dozwolono wideo-rozmowę. */
  public videoCommunicationEnabled: boolean;
  /** Czy włączono wysyłanie plików dla tej rezerwacji. */
  public multimediaEnabled: boolean;


  /** * Tablica wizyt z KlinikiXP, które zostały połączone z tą rezerwacją.
   */
  public visitXpList: VisitXp[];

  constructor() {
  }

  static construct(bookingData: BookingData, comment: string): VetReservation {
    if (bookingData && comment) {
      const vr: VetReservation = new VetReservation();

      vr.vetcodeId = bookingData.doctor.vetcodeId;
      vr.whObjId = bookingData.doctor.doctorId;
      vr.doctorUUID = bookingData.doctor.uuid;
      vr.doctorName = bookingData.doctor.doctorName;
      vr.visitTypeId = (bookingData.visitType ? bookingData.visitType.visitTypeId : null);
      vr.visitType = (bookingData.visitType ? bookingData.visitType.name : null);
      vr.startDateTime = bookingData.workHour.startDateTime;
      vr.endDateTime = bookingData.workHour.endDateTime;
      vr.email = bookingData.user.email;
      vr.comment = comment;
      vr.petName = bookingData.pet.name;
      vr.petUUID = bookingData.pet.uuid;

      return vr;
    }

    return null;
  }

  public areCommunicationToolsEnabled() {
    if (this.communicationToolsEnabled !== undefined) { return this.communicationToolsEnabled; }
    return false;
  }

  public areMultimediaEnabled() {
    if (this.multimediaEnabled !== undefined) { return this.multimediaEnabled; }
    return false;
  }

  public isVideoCommunicationEnabled() {
    if (this.videoCommunicationEnabled !== undefined) { return this.videoCommunicationEnabled; }
    return false;
  }

  public isOnline() {
    if (this.online !== undefined) { return this.online; }
    return false;
  }

 public getUuid() {
    return this.uuid;
  }
}
